import {
  TJK_MULTIPLIER_MIN_VALUE,
  TJK_MULTIPLIER_MAX_VALUE,
  TJK_MULTIPLE_COUPON_COUNT_MIN_VALUE,
  TJK_MULTIPLE_COUPON_COUNT_MAX_VALUE,
} from 'Store/constants';
import EnvironmentManager from 'Utils/environmentManager';


const inputMinMaxValidatorHorseRacing = (limitOption, isFixedOdd, systemSelected) => {
  let { id, value } = limitOption;
  if (systemSelected && isFixedOdd && id === 'multiplier') return { id, value };

  let maxValue = 1000;
  // eslint-disable-next-line no-nested-ternary
  let minValue = id === 'multiplier' ? ((isFixedOdd) ? Number(EnvironmentManager.getMessageText({ key: 'v1.betslip_fixodd.minimum_multiplier' }) || 20) : TJK_MULTIPLIER_MIN_VALUE) : TJK_MULTIPLE_COUPON_COUNT_MIN_VALUE;

  if (id === 'multiplier') {
    maxValue = TJK_MULTIPLIER_MAX_VALUE;
  } else {
    maxValue = TJK_MULTIPLE_COUPON_COUNT_MAX_VALUE;
  }

  if (maxValue && value > maxValue) value = maxValue;
  if (minValue && value < minValue) value = minValue;

  console.log('multiplier value', value);
  console.log('multiplier id', id);

  return { id, value };
};

export default inputMinMaxValidatorHorseRacing;
